// Action types for billing module
export const SET_BILLING = 'billing/SET_BILLING';
export const SET_PLAN_ID = 'billing/SET_PLAN_ID';
export const SET_SUBSCRIPTION_ID = 'billing/SET_SUBSCRIPTION_ID';
export const SET_SUBSCRIPTION_STATUS = 'billing/SET_SUBSCRIPTION_STATUS';
export const SET_PLAN_INFO = 'billing/SET_PLAN_INFO';
export const SET_PRODUCT_INFO = 'billing/SET_PRODUCT_INFO';
export const SET_SUBSCRIPTION_INFO = 'billing/SET_SUBSCRIPTION_INFO';
export const REFRESH_BILLING = 'billing/REFRESH_BILLING'; 